var data = {
	"body": "<path d=\"M27 18h3v-3a4.005 4.005 0 0 0-4-4h-1V9.5A3.504 3.504 0 0 0 21.5 6a3.456 3.456 0 0 0-1.5.351V5.41a3.41 3.41 0 0 0-6.545-1.343L11.341 9H9a5.006 5.006 0 0 0-5 5v4h4a5.006 5.006 0 0 0 5-5v-2.795l2.293-5.35A1.41 1.41 0 0 1 18 5.41V22h-3.388L11 25.294L7.388 22H2v2h4.612L11 28l4.388-4H30v-2H20V9.5a1.5 1.5 0 0 1 3 0V14a4.005 4.005 0 0 0 4 4zm-2-5h1a2.002 2.002 0 0 1 2 2v1h-1a2.002 2.002 0 0 1-2-2zm-14 0a3.003 3.003 0 0 1-3 3H6v-2a3.003 3.003 0 0 1 3-3h2z\" fill=\"currentColor\"/>",
	"width": 32,
	"height": 32
};
export default data;
